import { Button } from "../../../shared/ui";

type Props = {
  /** Same gate as `vm.canPlan` — computed once in `useWorkerTask`, passed through here. */
  canPlan: boolean;
  isTimeScheduled: boolean;
  onPlan: () => void;
  /**
   * 'header' sits inline in `PageLayout`'s button row — plain `Button`, no wrapper of its own.
   * 'bar' sits in the mobile bottom bar, sharing one row with the primary phase button — the
   * compact, half-width variant.
   */
  appearance: "header" | "bar";
};

/**
 * The one place "Umdisponieren" / "Im Kalender planen" is decided — the task-page counterpart of
 * `AppointmentSecondaryActions`. Returns a Fragment on purpose, same reasoning as there: the
 * desktop caller needs this as a direct child of `PageLayout`'s button row, the mobile caller as a
 * direct child of the bottom bar's own flex row.
 */
export const TaskSecondaryActions = ({ canPlan, isTimeScheduled, onPlan, appearance }: Props) => (
  <>
    {canPlan && (
      <Button
        variant="surface"
        size={appearance === "bar" ? "sm" : undefined}
        className={
          appearance === "bar"
            ? "flex-1 min-w-0 border-2 border-[#124093] !text-[#124093] flex items-center justify-center gap-1.5"
            : "!bg-[#124093] !text-white"
        }
        onClick={onPlan}
      >
        {/* Shortened for the bar's half-width column — the header keeps the full sentence. */}
        {appearance === "bar"
          ? isTimeScheduled ? "Umplanen" : "Planen"
          : isTimeScheduled ? "Umdisponieren" : "Im Kalender planen"}
      </Button>
    )}
  </>
);
